import $ from 'jquery';
import 'jquery-trend';
import 'jquery-revealer';
import 'imagesloaded';
import debounce from 'just-debounce';
import ShopifyVariants from 'shopify-variants';

import AddToCartButton from './AddToCartButton';
import CartMini from './CartMini';
import ImageZoom from './ImageZoom';
import RTE from './RTE';
import ShareThis from './ShareThis';

export default class Product {
  constructor(component) {
    this.el = component.el;
    this.$el = $(this.el);
    this.data = component.data;
    this.onScroll = this.onScroll.bind(this);
    this.setupProductDetails = this.setupProductDetails.bind(this);

    this.imagesJson = JSON.parse(this.el.querySelector('[data-images]').innerHTML);

    this.window = $(window);
    this.productArea = $('.product-area', this.el);
    this.thumbsCount = this.productArea.find('.thumb').length;

    this.productImages = this.productArea.find('.product-images');
    this.productMainImage = $('.product-main-image', this.el);
    this.productDetailsWrapper = this.productArea.find('.product-details-wrapper');
    this.productDetails = this.productArea.find('.product-details');
    this.$productToggleFullview = $('.product-toggle-fullview', this.el);

    this.rteEls = this.el.querySelectorAll('.rte');
    this.rtes = [];

    for (let i = 0; i < this.rteEls.length; i++) {
      this.rtes.push(new RTE(this.rteEls[i]));
    }

    this.addToCartTrigger = this.el.querySelector('[data-product-submit]');
    this.addToCartButton = new AddToCartButton(this.addToCartTrigger);

    this.cartMini = new CartMini();

    this.selectedThumbIndex = 0;
    this.processing = false;

    if ($('.zoom-enabled', this.el).length) {
      const pswpJsonElement = this.el.querySelector('[data-photoswipe-images]');

      if (pswpJsonElement) {
        const pswpJson = JSON.parse(pswpJsonElement.innerHTML);

        this.imageZoom = new ImageZoom(pswpJson.images);

        this.$el.on('click.product', '[data-image-zoom]', e => this.imageZoom.open(e.currentTarget));
      }
    }

    if (window.Shopify && Shopify.PaymentButton) {
      Shopify.PaymentButton.init();
    }

    this.eventId = `product-${this.el.id}`;

    this.setupProductDetailsDebounced = debounce(this.setupProductDetails.bind(this), 1000 / 60, false, true);

    if (this.data.productSettings.thumbOrientation === 'list') {
      this.setupProductDetails();
      this.window.on(`load.${this.eventId} resize.${this.eventId}`, this.setupProductDetailsDebounced);
      this.window.on(`scroll.${this.eventId}`, this.setupProductDetailsDebounced);
    }

    this.window.on(`shopify-variants:switch-variant.${this.eventId}`, (event, data) => this._onVariantSwitch(data.product, data.variant));
    this.window.on(`resize.product.${this.eventId}`, () => this.resize());

    $('.product-area .thumb', this.el).on('click.product', this.determineSelectedThumb.bind(this));
    $('.product-area .submit', this.el).on('click.product', (e) => {
      e.preventDefault();
      this.addToCart();
    });
    $('.product-area .single-option-selector', this.el).on('change.product', this.resetErrors.bind(this));

    this.shareThisEl = this.el.querySelector('[data-sharethis]');

    if (this.shareThisEl) {
      this.sharethis = new ShareThis(this.shareThisEl, this.productArea[0]);
    }

    this.setupVariants();
  }

  setupVariants() {
    const $variants = $('[data-variants]', this.el);
    const $options = $('[data-product-option]', this.el);

    if ($variants.length && $options.length) {
      this.variantHelpers = new ShopifyVariants(this.data.product, $variants, $options);
    }
  }

  onScroll() {
    const viewportWidth = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
    const viewportHeight = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);

    if (
      (viewportWidth > 770)
      && (viewportHeight > this.detailsHeight)
    ) {
      this.positionProductInfo(this.stickyNavHeight, this.detailsWrapperOffset, this.detailsHeight);
    } else {
      this.productDetails.css('position', 'static');
    }
  }

  resize() {
    this.resizeShowcase();
  }

  setupProductDetails() {
    this.mainHeaderWrap = $('.main-header-wrap');

    this.productDetails.width(this.productDetailsWrapper.width());

    if (this.mainHeaderWrap.attr('data-header-layout') !== 'minimal') {
      this.stickyNavHeight = 0;
      this.detailsWrapperOffset = this.productDetailsWrapper.offset().top - this.stickyNavHeight;
      this.detailsHeight = this.productDetails.outerHeight(true) + this.stickyNavHeight;
    } else {
      this.stickyNavHeight = $('.header-minimal').outerHeight(true);
      this.detailsWrapperOffset = this.productDetailsWrapper.offset().top;
      this.detailsHeight = this.productDetails.outerHeight(true);
    }

    this.onScroll();
  }

  positionProductInfo(stickyNavHeight, detailsWrapperOffset, detailsHeight) {
    const scrollTop = this.window.scrollTop() + stickyNavHeight;
    const detailsTop = this.productDetails.offset().top;
    let detailsBottom = detailsTop + detailsHeight;
    let imagesBottom = this.productImages.offset().top + this.productImages.outerHeight(true);

    if (this.productDetails.outerHeight() >= this.productImages.outerHeight(true)) { return; }

    const makeStatic = () => this.productDetails.css({
      position: 'static',
      bottom: '',
      top: '',
    });

    const makeAbsolute = () => this.productDetails.css({
      position: 'absolute',
      bottom: 0 + this.productArea.css('padding-bottom'),
      top: 'auto',
    });

    const makeFixed = () => this.productDetails.css({
      position: 'fixed',
      top: stickyNavHeight,
      bottom: '',
    });

    detailsBottom = this.productDetails.offset().top + detailsHeight;
    imagesBottom = this.productImages.offset().top + this.productImages.outerHeight(true);

    // We're not far enough down the page for any changes yet
    if ((detailsWrapperOffset - scrollTop) >= 0) {
      makeStatic();
      return;
    }

    // We're too far down the page and going back up
    if ((this.productImages.offset().top < scrollTop) && ((detailsTop - scrollTop) > 0)) {
      makeFixed();
      return;
    }

    if (
      !((detailsBottom + 1) >= imagesBottom) ||
      !(imagesBottom < (scrollTop + this.window.height()))
    ) {
      makeFixed();
    } else {
      makeAbsolute();
    }
  }

  handleErrors(response) {
    const error = JSON.parse(response.responseText);

    $('[data-product-form]', this.el).append(`<div class="error-message">${error.description}</div>`);

    this.timeout = setTimeout(() => {
      this.processing = false;
      this.addToCartButton.setState('error');
      setTimeout(() => this.addToCartButton.resetState(), 1000);
    }, 1000);
  }

  resetErrors() {
    $('.error-message', this.el).remove();
    this.processing = false;
  }

  addToCart() {
    if (this.processing) { return; }

    // Connect error handler
    // We need to do this each time because the quickshop might override it
    Shopify.onError = XMLHttpRequest => this.handleErrors(XMLHttpRequest);

    this.resetErrors();
    this.processing = true;
    this.addToCartButton.setState('loading');

    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: $('form[action="/cart/add"]', this.el).serialize(),
      success: () => {
        if (this.data.productSettings.cartRedirect) {
          window.location = '/cart';
          return;
        }

        this.cartMini.refresh();
        this.timeout2 = setTimeout(() => {
          this.addToCartButton.setState('success');
          this.cartMini.open();

          this.timeout3 = setTimeout(() => {
            this.addToCartButton.resetState();
            this.processing = false;
          }, 1000);
        }, 1000);
      },
      error: this.handleErrors.bind(this),
      dataType: 'json',
    });
  }

  resizeShowcase() {
    const container = this.productArea.find('.container');
    const imgHeight = container.find('img').height();

    if (this.productImages.attr('data-thumb-orientation') !== 'list') {
      container.height(imgHeight);
    }
  }

  determineSelectedThumb(e) {
    this.selectedThumbIndex = ($(e.currentTarget)).index();

    this.updateProductShowcase(this.productArea);
  }

  updateProductShowcase(parent) {
    const $showcaseContainer = parent.find('.showcase .container');
    const $showcaseWrap = $showcaseContainer.find('.wrap');
    const $showcaseImageNoScript = $showcaseContainer.find('[data-rimg-noscript]');
    const $showcaseImage = $showcaseContainer.find('img');
    const showcaseImageBeforeHeight = $showcaseImage.height();

    $showcaseContainer.height(showcaseImageBeforeHeight);

    const $activeThumb = parent.find('.thumb.active');
    const $selectedThumb = parent.find('.thumb').eq(this.selectedThumbIndex);
    const selectedThumbId = $selectedThumb.find('img').data('image-id');
    const imageHtml = this.imagesJson[selectedThumbId];

    if (this.selectedThumbIndex !== $activeThumb.index()) {
      const animationSpeed = 200;

      $showcaseWrap.fadeTo(animationSpeed, 0, () => {
        $showcaseImageNoScript.remove();
        $showcaseImage.remove();

        $showcaseWrap.prepend(imageHtml);

        $('img', $showcaseWrap).imagesLoaded(() => {
          const showcaseImageAfterHeight = $('img', $showcaseWrap).height();

          $showcaseContainer.animate(
            { height: showcaseImageAfterHeight },
            animationSpeed,
            'linear',
            () => {
              $activeThumb.removeClass('active');
              $selectedThumb.addClass('active');
              $showcaseWrap.fadeTo(animationSpeed, 1);
            },
          );
        });
      });
    }
  }

  unload() {
    clearTimeout(this.timeout);
    clearTimeout(this.timeout2);
    clearTimeout(this.timeout3);
    this.rtes.forEach(rte => rte.unload());
    this.window.off(`.${this.eventId}`);
    $(document).off('click.product');
    $('.product-area .thumb', this.el).off('click.product');
    $('.product-area .submit', this.el).off('click.product');
    $('.modal-wrap .close', this.el).off('click.product');
    $('.product-area .single-option-selector', this.el).off('change.product');

    if (this.variantHelpers) {
      this.variantHelpers.unload();
    }

    if (this.imageZoom) {
      this.imageZoom.unload();
    }

    if (this.shareThis) {
      this.sharethis.unload();
    }
  }

  _onVariantSwitch(product, variant) {
    if (product !== this.data.product) {
      return;
    }

    const { options } = variant;
    const $options = $('[data-product-option]', this.el);

    options.forEach((option, index) => {
      $options.eq(index).siblings('[data-selected-option]').text(option);
    });

    $('[data-product-variant-sku]', this.el).text(variant.sku || '');

    this._updatePrice(variant);
    this._updateImages(variant);
    this._updateHistory(variant);
  }

  _updateImages(variant) {
    const imageId = (variant.featured_image || this.data.product.featured_image).id;

    if (imageId == null) { return; }

    const $productThumbnails = $('.product-images .thumb img', this.productArea);

    $productThumbnails
      .filter(`[data-image-id='${imageId}']`)
      .parent()
      .trigger('click');
  }

  _updatePrice(variant) {
    const $addToCartButton = $('[data-product-submit]', this.productArea);
    const $priceFields = $('.product-details .price', this.productArea);

    if (variant) {
      for (let i = 0; i < $priceFields.length; i++) {
        const $moneyEl = $($priceFields[i]).children('.money');
        const { attributes } = $moneyEl[0];

        for (let j = 0; j < attributes.length; j++) {
          const attribute = attributes[j];

          if (attribute.name.indexOf('data-') > -1) {
            $moneyEl.attr(attribute.name, '');
          }
        }
      }

      if (variant.available) {
        $addToCartButton
          .val(this.data.productSettings.addToCartText)
          .removeClass('disabled')
          .removeAttr('disabled');
      } else {
        $addToCartButton
          .val(this.data.productSettings.soldOutText)
          .addClass('disabled')
          .attr('disabled', 'disabled');
      }

      if (variant.compare_at_price > variant.price) {
        $priceFields
          .find('.money:not(.original)')
          .html(Shopify.formatMoney(variant.price, Theme.moneyFormat))
          .attr(`data-currency-${Theme.currency}`, Shopify.formatMoney(variant.price, Theme.moneyFormat))
          .attr('data-currency', Theme.currency);
        $priceFields
          .find('.money.original')
          .html(Shopify.formatMoney(variant.compare_at_price, Theme.moneyFormat))
          .removeClass('hidden')
          .attr(`data-currency-${Theme.currency}`, Shopify.formatMoney(variant.compare_at_price, Theme.moneyFormat))
          .attr('data-currency', Theme.currency);
      } else {
        $priceFields
          .find('.money:not(.original)')
          .html(Shopify.formatMoney(variant.price, Theme.moneyFormat))
          .attr(`data-currency-${Theme.currency}`, Shopify.formatMoney(variant.price, Theme.moneyFormat))
          .attr('data-currency', Theme.currency);
        $priceFields
          .find('.money.original')
          .addClass('hidden')
          .attr(`data-currency-${Theme.currency}`, Shopify.formatMoney(variant.compare_at_price, Theme.moneyFormat))
          .attr('data-currency', Theme.currency);
      }
    } else {
      // Variant doesn't exist
      $addToCartButton
        .val(this.data.productSettings.unavailableText)
        .addClass('disabled')
        .attr('disabled', 'disabled');
    }

    if (Theme.currencySwitcher) {
      $(document).trigger('switch-currency');
    }
  }

  _updateHistory(variant) {
    if (!this.data.productSettings.enableHistory || (variant == null)) { return; }

    const newUrl = [
      window.location.protocol,
      '//',
      window.location.host,
      window.location.pathname,
      '?variant=',
      variant.id,
    ];

    const variantUrl = newUrl.join('');
    window.history.replaceState({ path: variantUrl }, '', variantUrl);
  }
}
